import React, {FC, useEffect, useState} from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
} from 'reactstrap';
import {Link} from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import './datatables.scss';
import {useDispatch, useSelector} from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import {
  getCustomers,
} from '../../store/actions';
import {getLoggedInUser} from '../../helpers/fakebackend_helper';
import {ROLE, RoleNameMap} from '../../components/Role/constants';
import {getCustomersSelector} from '../../selectors/customer';
import {CustomerList} from '../../components/Customer/CustomerList';
import {createLoadingSelector} from '../../selectors/loading';
import {GET_CUSTOMERS} from '../../store/customers/actionTypes';

const CustomersOverview: FC = () => {
  const allCustomers = useSelector(getCustomersSelector);
  const dispatch = useDispatch();

  const authUser = getLoggedInUser();
  const userRole = RoleNameMap.get(authUser.user.role) || ROLE.NONE;

  const [customers, setCustomers] = useState<OverviewCustomer[]>(allCustomers);
  const customersLoadingSelector = useSelector(
      createLoadingSelector([GET_CUSTOMERS]),
  );

  const [customersLoading, setCustomersLoading] = useState(true);

  useEffect(() => {
    dispatch(getCustomers());
  }, [dispatch]);

  // Could be done in the other useEffect, but when Filters are used
  // separate are needed
  useEffect(() => {
    setCustomers(allCustomers);
  }, [allCustomers]);

  useEffect(() => {
    setCustomersLoading(customersLoadingSelector);
  }, [customersLoadingSelector]);

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Customers" breadcrumbItem="Overview"/>
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                {[
                  ROLE.BROTHER_MANAGER,
                  ROLE.BROTHER_STAFF,
                  ROLE.DEALER_ENGINEER,
                ].includes(userRole) &&
                  <div className="text-sm-right">
                    <Link to={{
                      pathname: '/add-customer',
                    }}>
                      <Button
                        type="button"
                        color="yellow"
                        className="btn-rounded waves-effect waves-light mb-2
                        mr-2"
                      >
                        <i className="mdi mdi-plus mr-1"/>
                          Add New Customer
                      </Button>
                    </Link>
                  </div>
                }
                <CustomerList
                  customers={customers}
                  isLoading={customersLoading}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CustomersOverview;
